// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table td.flight-purpose-code,\n.el-table th.flight-purpose-code {\n  width: 8em;\n}", ""]);
// Exports
module.exports = exports;
